<template>
  <v-dialog
    v-model="dialog"
    max-width="620px"
    class="rounded-lg"
    persistent
    scrollable
  >
    <v-card class="base rounded-lg" tile>
      <v-toolbar flat dark color="base">
        <v-toolbar-title>
          Editar variação:
          <strong
            ><u>
              {{ editedItem.descricao }}
            </u></strong
          >
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn class="mt-0 mr-0" dark icon @click="close">
          <CloseIcon />
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <v-list
          three-line
          subheader
          class="rounded-t-lg"
          :class="{ 'rounded-b-lg': !hasLote }"
        >
          <v-subheader class="font-weight-bold">Geral</v-subheader>
          <v-list-item>
            <v-list-item-content>
              <v-row>
                <v-col cols="6">
                  <BaseMoneyField
                    label="Preço"
                    placeholder="Ex: 100,00"
                    v-model="editedItem.preco"
                    :options="moneyFieldConfig"
                  ></BaseMoneyField>
                </v-col>
                <v-col cols="6">
                  <BaseTextField
                    v-model="editedItem.quantidade"
                    label="Quantidade"
                    placeholder="Ex: 100"
                  />
                </v-col>
                <v-col cols="6">
                  <BaseSelect
                    label="Status"
                    placeholder="Ex: Ativo"
                    item-text="text"
                    item-value="value"
                    :items="status"
                    v-model="editedItem.status"
                    :attach="false"
                  />
                </v-col>
                <v-col v-if="hasLote">
                  <v-dialog
                    ref="menu"
                    v-model="menu"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    persistent
                    width="290px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <BaseTextField
                        readonly
                        label="Data e Hora virada de lote"
                        type="tel"
                        v-model="formattedDateTime"
                        v-bind="attrs"
                        v-on="on"
                        @click="openDatePickers"
                        placeholder="dd/mm/aaaa hh:mm"
                        append-icon="mdi-calendar-clock"
                        persistent-hint
                        :hint="batchTurnoverExplain"
                        clearable
                        @click:clear="clearDateAndTime"
                      >
                      </BaseTextField>
                    </template>
                    <v-date-picker
                      v-if="activePicker === 'DATE'"
                      v-model="dateValue"
                      :min="minInitDate"
                      @change="onDateChange"
                      locale="pt"
                      color="primary"
                      class="rounded-lg"
                    >
                      <v-spacer></v-spacer>
                      <v-btn
                        text
                        color="primary"
                        @click="menu = false"
                        class="rounded-lg"
                      >
                        Cancelar
                      </v-btn>
                      <v-btn
                        text
                        class="rounded-lg"
                        color="primary"
                        @click="$refs.menu.save(dateValue)"
                      >
                        OK
                      </v-btn>
                    </v-date-picker>
                    <v-time-picker
                      v-if="activePicker === 'TIME'"
                      v-model="timeValue"
                      @input="onTimeInput"
                      locale="pt"
                      scrollable
                      format="24hr"
                      color="primary"
                      range
                    >
                      <v-spacer></v-spacer>
                      <v-btn
                        text
                        color="primary"
                        @click="menu = false"
                        class="rounded-lg"
                      >
                        Cancelar
                      </v-btn>
                      <v-btn
                        text
                        class="rounded-lg"
                        color="primary"
                        @click="$refs.menu.save(timeValue)"
                      >
                        OK
                      </v-btn>
                    </v-time-picker>
                  </v-dialog>
                </v-col>
              </v-row>
            </v-list-item-content>
          </v-list-item>
        </v-list>
        <v-divider></v-divider>
        <v-list three-line subheader :class="{ 'rounded-b-lg': !hasLote }">
          <v-subheader class="font-weight-bold"
            >Cortesia/Gratuídade</v-subheader
          >
          <v-radio-group v-model="editedItem.taxa" class="mx-4">
            <template v-slot:label>
              <div>Selecione se essa variação é:</div>
            </template>
            <v-radio
              value="GRATUIDADE"
              class="rounded-lg pa-2"
              style="border: 1px solid rgb(0 0 0 / 42%)"
              active-class="active-class"
            >
              <template v-slot:label>
                <div>
                  Gratuídade<br />
                  <small>Aplicar gratuídade a essa variação.</small>
                </div>
              </template>
            </v-radio>
            <v-radio
              value="CORTESIA"
              class="rounded-lg pa-2"
              style="border: 1px solid rgb(0 0 0 / 42%)"
              active-class="active-class"
            >
              <template v-slot:label>
                <div>
                  Cortesia<br />
                  <small>Aplicar cortesia a essa variação.</small>
                </div>
              </template>
            </v-radio>
          </v-radio-group>
        </v-list>
        <v-divider v-if="hasLote"></v-divider>
        <v-list three-line subheader class="rounded-b-lg" v-if="hasLote">
          <v-subheader class="font-weight-bold">
            Lote
            <v-spacer></v-spacer>
            <v-btn dense class="button rounded-lg" small @click="resetLote"
              >Remover Lote</v-btn
            >
          </v-subheader>
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title>Selecione o lote anterior:</v-list-item-title>
              <v-list-item-subtitle>
                Essa variação será vendida após o termino do lote anterior
                selecionado.
              </v-list-item-subtitle>
              <v-radio-group
                dense
                v-model="editedItem.idprod_var_lote"
                class="radio-group"
              >
                <v-radio
                  v-for="(variacao, index) in tableValues"
                  :key="index"
                  :label="variacao.descricao"
                  :value="
                    variacao.id_tmp
                      ? variacao.id_tmp
                      : variacao.idproduto_variacao
                  "
                  class="rounded-lg pa-2"
                  style="border: 1px solid rgb(0 0 0 / 42%)"
                  active-class="active-class"
                >
                  {{ variacao }}
                </v-radio>
              </v-radio-group>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-card-text>
      <v-card-actions class="pr-6 pb-4">
        <v-spacer></v-spacer>
        <v-btn class="order-2 rounded-lg" dark dense @click="save"
          >Salvar</v-btn
        >
        <v-btn
          class="rounded-lg mr-4 order-1"
          color="transparent"
          elevation="0"
          @click="close"
          >Cancelar</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import _ from "lodash";
import CloseIcon from "@/components/icons/CloseIcon.vue";
import BaseMoneyField from "@/components/forms/BaseMoneyField.vue";
import BaseTextField from "@/components/forms/BaseTextField.vue";
import BaseSelect from "@/components/forms/BaseSelect.vue";
import products from "@/mixins/products.js";
import dayjs from "dayjs";
export default {
  name: "ModalEditarVariacao",
  mixins: [products],
  components: {
    BaseMoneyField,
    BaseTextField,
    BaseSelect,
    CloseIcon,
  },
  props: {
    dialog: {
      type: Boolean,
    },
    editedItem: {
      type: Object,
    },
    defaultItem: {
      type: Object,
    },
    editedIndex: {
      type: Number,
    },
  },
  data: () => ({
    variacoes: [],
    menu: false,
    activePicker: "",
    dateValue: null,
    timeValue: null,
    formattedDateTime: "",
    moneyFieldConfig: {
      locale: "pt-BR",
      prefix: "R$",
      suffix: "",
      length: 9,
      precision: 2,
    },
    batchTurnoverExplain: "ℹ️ A virada de lote será realizada automaticamente na data e horário especificados. No caso do estoque deste lote atingir zero, a troca de lote será efetuada automaticamente no momento em que o estoque ficar esgotado."
  }),
  methods: {
    openDatePickers() {
      this.activePicker = "DATE";
      this.formattedDateTime = "";
      this.menu = true;
      this.dateValue = null;
      this.timeValue = null;
    },
    clearDateAndTime() {
      this.dateValue = null;
      this.timeValue = null;
      this.formattedDateTime = "";
      this.editedItem.dthr_virada_lote = null;
    },
    close() {
      this.clearDateAndTime();
      this.$emit("close");
    },
    save() {
      if (this.editedIndex > -1) {
        Object.assign(
          this.$produtos_gerenciar.cadastro.variacoes.variacoes_produtos[
            this.editedIndex
          ],
          this.editedItem
        );
      } else {
        this.$produtos_gerenciar.cadastro.variacoes.variacoes_produtos.push(
          this.editedItem
        );
      }

      this.close();
    },
    resetLote() {
      this.editedItem.idprod_var_lote = null;
    },
    updateFormattedDateTime() {
      try {
        const formattedDate = this.dateValue
          ? dayjs(this.dateValue).format("DD/MM/YYYY")
          : "";

        this.formattedDateTime = formattedDate;

        if (formattedDate && this.timeValue) {
          const formattedTime = this.timeValue;

          const combinedDateTime = `${formattedDate} ${formattedTime}`;
          this.formattedDateTime = combinedDateTime;
          this.editedItem.dthr_virada_lote = dayjs(
            combinedDateTime,
            "DD/MM/YYYY HH:mm"
          ).format("YYYY-MM-DD HH:mm");
        } else {
          this.editedItem.dthr_virada_lote = null;
        }
      } catch (error) {
        console.error("Error formatting date and time:", error);
      }
    },
    onDateChange() {
      this.activePicker = "TIME";
    },
    onTimeInput() {
      this.updateFormattedDateTime();
    },
  },
  computed: {
    minInitDate() {
      return dayjs().format("YYYY-MM-DD");
    },
    /**
     * @description Propriedade computada que remove tags de tradução das variações
     */
    tableValues() {
      this.$produtos_gerenciar?.cadastro.variacoes.variacoes_produtos.forEach(
        item => {
          item.descricao = this.$config?.convertTagString(item.descricao);
        }
      );

      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.variacoes =
        this.$produtos_gerenciar?.cadastro.variacoes.variacoes_produtos.filter(
          item => {
            return item.descricao != this.editedItem?.descricao;
          }
        );
      return _.orderBy(this.variacoes, "descricao");
    },
    hasLote() {
      return this.$produtos_gerenciar.cadastro.variacoes.gerenciar_lote;
    },
  },
  watch: {
    dialog(val) {
      val || this.close();
    },
    "editedItem.preco"(e) {
      // if(e) {
      return new Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL",
        minimumFractionDigits: 2,
      }).format(Number.parseFloat(e));
      // }
    },
    "editedItem.dthr_virada_lote"(newVal) {
      if (newVal) {
        const parsedDateTime = dayjs(newVal, "YYYY-MM-DD HH:mm");
        this.dateValue = parsedDateTime.isValid()
          ? parsedDateTime.toDate()
          : null;
        this.timeValue = parsedDateTime.isValid()
          ? parsedDateTime.toDate()
          : null;
        this.formattedDateTime = dayjs(newVal, "YYYY-MM-DD HH:mm").format(
          "DD/MM/YYYY HH:mm"
        );
      } else {
        this.dateValue = null;
        this.timeValue = null;
      }
    },
  },
};
</script>
<style scoped>
.v-card {
  border-width: 0 !important;
}
.radio-group {
  width: 50%;
}
.active-class {
  background-color: #e6f7ff !important;
  border-color: #91d5ff !important;
  color: #1890ff !important;
}
</style>
